import { get } from 'lodash';
import { ReactNode, useCallback, useEffect } from 'react';
import { useFiltersContext } from '../hooks';
import { FilterComponentBaseProps, FilterConfigWithValue } from '../types/filter.types';
import { Chip } from '@nexelem/components';
import { faSquareXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type ActiveFilterChipProps = Omit<FilterComponentBaseProps, 'value' | 'isMultiple'> & {
  label: string;
  Icon?: ReactNode;
};

export const FilterChipToggle = ({
  path,
  register,
  label,
  Icon = <FontAwesomeIcon icon={faSquareXmark} />,
}: ActiveFilterChipProps) => {
  const { onChange, filters } = useFiltersContext();
  const filterValue = get(filters, path, { value: false }) as FilterConfigWithValue<boolean | undefined>;

  useEffect(() => {
    register({
      path,
      isMultiple: false,
      value: false,
    });
  }, [path, register]);

  const handleIsSelected = useCallback(() => {
    onChange(path, {
      value: !filterValue.value,
      isMultiple: false,
    });
  }, [filterValue.value, onChange, path]);

  return <Chip label={label} selected={!!filterValue.value} StartIcon={Icon} onClick={handleIsSelected} />;
};
